import loadingTemp from '@/views/common/loading.vue'

let Load = {};  // 定义插件对象

Load.install = (Vue, options) => { //Vue的install方法，用于定义vue插件
    // 如果存在loading 不重复创建DOM
    if (document.getElementsByClassName('.loading').length) return

    // 创建一个VUE构造器
    let lTemp = Vue.extend(loadingTemp);

    // 实例化VUE实例
    let $vm = new lTemp();

    $vm.showLoading = true;

    // 此处使用$mount来手动开启编译。用$el来访问元素，并插入到body中
    let tpl = $vm.$mount().$el;
    document.body.appendChild(tpl);

    Vue.prototype.$loading = { //在Vue的原型上添加实例方法，以全局调用
        show() {
            $vm.showLoading = true;
        },
        hide() {
            $vm.showLoading = false;
        }
    }
}
//导出Load
export default Load;